/**
 * Lite mode — runtime perf flag for low-end devices.
 *
 * Set on `<html>` once in main.tsx via `detectLiteMode`. Read here so
 * modules (simulator, MapView, App) can branch on it.
 *
 * Effects in lite mode:
 *   • Simulator runs at ~12 Hz instead of 60 Hz (per-second JS load drops 5×).
 *   • Map rotation is disabled — always north-up. Skipping setBearing
 *     spares MapLibre a full re-render every frame.
 *   • Trail breadcrumbs + traffic markers are skipped.
 *   • Maneuver inset is hidden — that's a whole second MapLibre instance
 *     with its own GL context, not worth it on a weak GPU.
 *   • CSS effects (backdrop-blur, pulses, film grain, heavy shadows)
 *     are stripped via `.lite` style rules in global.css.
 */
export const IS_LITE: boolean =
  typeof document !== "undefined" &&
  document.documentElement.classList.contains("lite");
